<template>
  <div>
    <div
      v-if="showCarSimulating"
      class="col-sm-6 trip-simulation-container ps-1 pb-1 pe-1"
      style="float: right"
    >
      <div>
        <div class="row">
          <div class="col-4">
            <div class="col-12 speed-value-container d-flex justify-content-end">
              {{ trip && trip.speed && trip.speed[currentPoint] !== null ? trip.speed[currentPoint] : '-' }}
            </div>
          </div>
          <div class="col-3 speed-container  d-flex justify-content-start">
            km/h
          </div>
          <div class="col-3 text-center">
            <div class="player-control-container">
              <font-awesome-icon
                  v-if="carPositionSimulating"
                  icon="pause"
                  class="player-contols"
                  @click.stop="pauseCarPosition"
              />
              <font-awesome-icon
                v-else
                icon="play"
                class="player-contols"
                style="margin-left: .55em"
                @click.stop="continueCarPosition"
              />
            </div>
          </div>
          <div class="col-2 text-center">
            <div
              class="row p-1 speed-button"
              @click.stop="increaseSpeed"
            >
              +
            </div>
            <div
              class="row p-1 speed-button"
              @click.stop="decreaseSpeed"
            >
              -
            </div>
          </div>
        </div>
        <div class="col-12 player-sub-value text-center">
          {{ trip && trip.timestamps && trip.timestamps[currentPoint] ? toLocalTime(trip.timestamps[currentPoint]) : '-' }}
        </div>
        <div class="slider-container nopads p-1 ps-2 pe-2">
            <VueSlider
                v-model="currentPoint"
                :min="0"
                :tooltip="'none'"
                :max="maxValue"
                @change="changeCarPosition"
                :dot-style="dotStyle"
                :process-style="processStyle"/>
        </div>
        <div class="row">
          <div class="col-6 player-subtitle">
            {{ $t('trip.distance_km') }}
          </div>
          <div class="col-6 player-subtitle">
              {{ $t('trip.time') }}
          </div>
        </div>
        <div class="row">
          <div class="col-3 player-sub-value d-flex justify-content-end">
            {{ Math.min(trip.length, distanceProgress / 1000).toFixed(2) }}
          </div>
          <div class="col-3 player-sub-value d-flex justify-content-start">
            / {{ trip.length.toFixed(2) }}
          </div>
          <div class="col-3 player-sub-value d-flex justify-content-end">
            {{ getWorkTime(Math.round(timeProgress)) }}
          </div>
            <div class="col-3 player-sub-value d-flex justify-content-start">
            / {{ getWorkTime(Math.round(tripTime)) }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {logModes, vehicleHelper} from '../mixins/VehicleMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {measureDistanceMixin} from "@/components/mixins/MeasureDistanceMixin";
import VueSlider from 'vue-3-slider-component'
import {restApi} from "@/components/mixins/RestApiMixin";

export default {
    name: 'TripMap',
    mixins: [timeUtils, vehicleHelper, mapHelper, measureDistanceMixin, restApi],
    components: { VueSlider },
    props: {
        tripResults: {
            type: Array,
            default: function () {
                return []
            }
        },
        tripItem: {
            type: Object,
            default: null
        },
        map: {
            type: Object,
            default: null
        },
        areaGroup: {
            type: Object,
            default: null
        },
        customArea: {
            type: Array,
            default: null
        },
        showTripInfo: {
            type: Boolean,
            default: true
        },
        lineOpacity: {
            type: Number,
            default: 1
        },
        lineWidth: {
            type: Number,
            default: 0
        },
        staticLineColor: {
            type: String,
            default: null
        },
        pointHover: {
            type: Boolean,
            default: false
        },
        showEndPoints: {
            type: Boolean,
            default: false
        },
        traceType: {
            type: Number,
            default: 8  // Map mixins TRACE
        },
    },

    data: function () {
        return {
            loading: false,
            showDetails: false,
            trips: [],
            trip: null,
            intervalNum: null,
            currentPoint: 0,
            markerStore: null,
            carMarkerId: 88888,
            simulationSpeed: 50,
            tripMapColor: null,
            visibleGroup: null,
            showCarSimulating: false,
            carPositionSimulating: false,
            distanceProgress: 0,
            timeProgress: 0,
            tripTime: 0,
            drawnTrip: [],
            firstMarkerId: 1,
            secondMarkerId: 2,
            firstPoint: null,
            secondPoint: null,
            visibleCustomArea: null,
            dotStyle: {
                backgroundColor: '#BEFF41', // Custom color for the thumb
                borderColor: '#90b677'
            },
            processStyle: {
                height: '.25em',
                backgroundColor: '#BEFF41' // Custom color for the filled track
            },
            fields: [
                { key: "driver", label: this.$t('trip_list.driver')},
                { key: "vehicle" , label: this.$t('trip_list.vehicle')},
                { key: "mode", label: this.$t('trip_list.mode')},
                { key: "customer", label: this.$t('contracts.customer')},
                { key: "contract", label: this.$t('orders.contract')},
                { key: "order", label: this.$t('vehicle_position.order')},
                { key: "startTime", label: this.$t('trip_list.start_time')},
                { key: "startRoad", label: this.$t('trip_list.start_loc')},
                { key: "endTime", label: this.$t('trip_list.end_time')},
                { key: "endRoad", label: this.$t('trip_list.end_loc')},
                { key: "length", label: this.$t('trip_list.trip_length')}
            ]
        }
    },

    computed: {
        maxValue() {
            return this.trip.timestamps.length > 0 ? this.trip.timestamps.length - 1 : 0;
        }
    },

    watch: {
        tripResults: function () {
            this.resetMap()
            this.initView()
        },
        tripItem: function () {
            this.resetMap()
            this.initView()
        },
        areaGroup: function () {
            this.hideAreas()
            if (this.areaGroup) {
                this.fetchAreaGroup(this.areaGroup.id)
            }
        },
        customArea: function () {
            this.hideAreas()
            if (this.customArea) {
                this.visibleCustomArea = this.customArea
                this.map.drawPolygon(0, this.visibleCustomArea, this.AREA, '#1c455b', '#1c455b', 0.9)
            }
        }
    },

    mounted: function () {
        this.initView()
    },
    methods: {

        toLatLng(value) {
            return value.map(coord => {
                return {
                    lat: coord.y,
                    lng: coord.x
                }
            });
        },

        initView: function () {
            if (!this.visibleGroup && this.areaGroup) {
                this.fetchAreaGroup(this.areaGroup.id)
            }
            if (!this.visibleCustomArea && this.customArea) {
                this.visibleCustomArea = this.customArea
                this.map.drawPolygon(0, this.visibleCustomArea, this.AREA, '#1c455b', '#1c455b', 0.9)
            }
            this.markerStore = this.map.getMarkerStore()
            if (this.trips || this.trip) {
                this.hideTrips()
            }
            this.trips = this.tripResults
            this.trip = this.tripItem
            if (this.trip && this.trip.geometry) {
                this.drawnTrip = this.trip.geometry
                this.drawTrip(this.trip, this.showTripInfo)
                if (this.traceType === this.TRACE) {
                    this.map.zoomToGroup(this.traceType)
                }
                if (this.showEndPoints) {
                    this.setupLineSelection()
                }
            } else if (this.trips && this.trips.length > 0) {
                this.drawTrips()
            }
        },

        onDragEnd(data) {
            const id = data.id
            const pos = data.latlng
            const line = this.toLatLng(this.drawnTrip)
            if (id === this.firstMarkerId) {
                this.firstPoint = this.map.getNearestLatLngIndex(pos, line)
            } else if (id === this.secondMarkerId) {
                this.secondPoint = this.map.getNearestLatLngIndex(pos, line)
            }
            this.drawSelectedLine()
        },

        setupLineSelection() {
            this.firstPoint = 0
            this.secondPoint = this.drawnTrip.length - 1
            this.drawSelectedLine()
        },

        getPosition(id) {
            const index = id === this.firstMarkerId ? Math.min(this.firstPoint, this.secondPoint) : Math.max(this.firstPoint, this.secondPoint);
            return this.drawnTrip[index];
        },


        drawSelectedLine() {
            const first = Math.min(this.firstPoint, this.secondPoint + 1) //slice
            const second = Math.max(this.firstPoint, this.secondPoint + 1) //slice
            const selectedLine = this.drawnTrip.slice(first, second)
            let positionNew = this.getPosition(this.firstMarkerId)
            this.map.showMapMarker(this.firstMarkerId, this.traceType, positionNew.y, positionNew.x, this.markerStore.getCircleIcon(), true)
            positionNew = this.getPosition(this.secondMarkerId)
            this.map.showMapMarker(this.secondMarkerId, this.traceType, positionNew.y, positionNew.x, this.markerStore.getCircleIcon(), true)
            let id = this.trips && this.trips.length > 0 ? this.trips.length : 1
            this.map.drawPolyLine(id, this.traceType, selectedLine, '#61cc0c', false, false, 5);
            this.$emit('routePartSelected', selectedLine)
        },

        decreaseSpeed() {
            if (this.simulationSpeed < 300) {
                this.stopUpdateCarPosition()
                this.simulationSpeed += 10;
                this.continueCarPosition()
            }
        },

        increaseSpeed() {
            if (this.simulationSpeed > 10) {
                this.stopUpdateCarPosition()
                this.simulationSpeed -= 10;
                this.continueCarPosition()
            }
        },


        showMovingCar: function () {
            if(!this.carPositionSimulating) {
                this.map.removePolyline(0, this.traceType)
                this.map.drawSimulatedRoute(0, this.trip.geometry)
                this.currentPoint = 0
                this.distanceProgress = 0
                this.timeProgress = 0
                let timeA = new Date(this.trip.timestamps[0])
                let timeB = new Date(this.trip.timestamps[this.trip.timestamps.length-1])
                this.tripTime = (timeB.getTime() - timeA.getTime()) / (1000 * 60)
                this.showCarSimulating = true
                this.carPositionSimulating = true
                this.$emit('carPositionSimulating', this.carPositionSimulating)
                let repetitionInterval = 50
                this.intervalNum = setInterval(() => this.updateCarPosition(), repetitionInterval)
            }
        },

        stopUpdateCarPosition: function () {
            this.carPositionSimulating = false
            this.currentPoint--
            clearInterval(this.intervalNum)
        },

        hideSimulatedCar: function () {
            if(this.carMarkerId){
                this.map.removeMapMarker(this.carMarkerId, this.VEHICLE)
            }
        },

        hideSimulatedTracks: function () {
            if(this.trip){
                this.map.removePolyline(0, this.traceType)
                this.map.hideSimulatedRoute(0)
            }
        },

        hideSimulation() {
            this.showCarSimulating = false
            this.stopUpdateCarPosition()
            this.hideSimulatedCar()
            this.hideSimulatedTracks()
        },

        resetMap: function () {
            this.hideSimulation()
            this.hideTrips()
        },

        updateCarPosition: function () {
            this.currentPoint++
            if (this.trip && this.currentPoint < this.trip.geometry.length) {
                this.$emit('setCurrentPoint', this.currentPoint)
                this.map.showMapMarker(this.carMarkerId, this.VEHICLE,
                    this.trip.geometry[this.currentPoint].y,
                    this.trip.geometry[this.currentPoint].x,
                    this.markerStore.getActiveCarIcon())
                // Update distance and update time
                this.distanceProgress += this.getPointDistance(this.trip.geometry[this.currentPoint-1], this.trip.geometry[this.currentPoint])
                let timeA = new Date(this.trip.timestamps[this.currentPoint-1])
                let timeB = new Date(this.trip.timestamps[this.currentPoint])
                this.timeProgress += (timeB.getTime() - timeA.getTime()) / (1000 * 60)
                // Update car on the map
                this.map.drawRouteProgressPolyLine(this.currentPoint, 0, false, this.tripMapColor)
            } else {
                this.stopUpdateCarPosition()
            }
        },

        changeCarPosition: function () {
            if (this.trip && this.currentPoint < this.trip.geometry.length && this.currentPoint >= 0) {
                // Emit the current point for any external listeners
                this.$emit('setCurrentPoint', this.currentPoint);
                // Update the car marker position on the map
                this.map.showMapMarker(
                    this.carMarkerId,
                    this.VEHICLE,
                    this.trip.geometry[this.currentPoint].y,
                    this.trip.geometry[this.currentPoint].x,
                    this.markerStore.getActiveCarIcon()
                );

                this.distanceProgress = 0;
                for (let i = 1; i <= this.currentPoint; i++) {
                    this.distanceProgress += this.getPointDistance(this.trip.geometry[i - 1], this.trip.geometry[i]);
                }

                this.timeProgress = 0;
                for (let i = 1; i <= this.currentPoint; i++) {
                    let timeA = new Date(this.trip.timestamps[i - 1]);
                    let timeB = new Date(this.trip.timestamps[i]);
                    this.timeProgress += (timeB.getTime() - timeA.getTime()) / (1000 * 60); // Convert to minutes
                }

                // Update the route progress on the map
                this.map.drawRouteProgressPolyLine(this.currentPoint, 0, false, this.tripMapColor);
            }
        },

        pauseCarPosition: function () {
            this.carPositionSimulating = false
            this.$emit('carPositionSimulating', this.carPositionSimulating)
            clearInterval(this.intervalNum)
        },

        continueCarPosition() {
            if (this.currentPoint === this.trip.geometry.length-1) {
                this.showMovingCar()
            } else {
                this.carPositionSimulating = true
                this.$emit('carPositionSimulating', this.carPositionSimulating)
                this.intervalNum = setInterval(() => this.updateCarPosition(), this.simulationSpeed)
            }
        },

        drawTrips: function () {
            this.trips.forEach(function (trip, index) {
                this.drawTrip(trip, false, index)
            }, this)
            if (this.traceType === this.TRACE) {
                this.$nextTick(() => this.map.zoomToGroup(this.traceType))
            }
        },

        drawTrip: function (trip, showInfo, id = 0) {
            if (trip.geometry) {
                let color = ''
                let dash = false
                const arrow = false
                let width = this.lineWidth > 0 ? this.lineWidth : 3
                if (this.showEndPoints) {
                    color = '#565659'
                } else {
                    switch (trip.mode) {
                        case logModes.WORK:
                            width = 5
                            if (trip.color) {
                                color = this.staticLineColor ? this.staticLineColor : trip.color
                            } else {
                                color = this.staticLineColor ? this.staticLineColor : '#00FF21'
                            }
                            break
                        case logModes.PROGRAM:
                            color = '#2121FF'
                            break
                        case logModes.RESETTLE:
                            color = this.staticLineColor ? this.staticLineColor : '#89898a'
                            dash = true
                            break
                    }
                }
                this.tripMapColor = color
                this.map.drawPolyLine(id, this.traceType, trip.geometry, color, dash, arrow, width, this.lineOpacity, false, false, null, this.pointHover)
            }
            if (showInfo) {
                this.showInfo(trip)
            }
        },

        hideTrips: function () {
            this.map.removePolylinesByType(this.traceType)
            this.map.hideMapInfo()
            this.trips = []
            this.trip = null
            this.showDetails = false
        },

        showInfo: function (trip) {
            this.map.showMapInfo(this.fields, [{
                driver: trip.driver,
                vehicle: trip.vehicle,
                mode: this.getTripModeString(trip.mode),
                customer: trip.customer ? trip.customer : '-',
                contract: trip.contract ? trip.contract : '-',
                order: trip.order ? trip.order : '-',
                startTime: this.getDateString(trip.start_time),
                startRoad: trip.start_road,
                endTime: this.getDateString(trip.end_time),
                endRoad: trip.end_road,
                length: parseFloat(trip.length.toFixed(1)).toLocaleString()
            }], true)
        },

        onMapInfoClosed: function () {
            this.showDetails = false
        },

        onPolylineTap: function (data) {
            if (data.type && data.type === this.traceType) {
                if (this.showDetails) {
                    this.map.hideMapInfo()
                    this.showDetails = false
                // What? if and else if are same
                } else if (this.showDetails) {
                    // Show info for the corresponding item
                    if (this.trips && this.trips.length > 0) {
                        var trip = this.trips[data.id]
                        if (trip) {
                            this.showInfo(trip)
                            this.showDetails = true
                        }
                    } else if (this.trip) {
                        this.showInfo(this.trip)
                        this.showDetails = true
                    }
                }
                this.$emit('tripClicked', data.id)
            }
        },

        isCarPositionSimulating() {
            return this.carPositionSimulating
        },

        showAreas: function () {
            if (this.visibleGroup) {
                this.visibleGroup.areas.forEach(area =>  {
                    if (area.geometry) {
                        if (area.color) {
                            this.map.drawPolygon(area.id, area.geometry.rings, this.AREA,  area.color, area.color, 0.9)
                        } else {
                            this.map.drawPolygon(area.id, area.geometry.rings, this.AREA, '#1c455b', '#1c455b', 0.9)
                        }
                    }
                })
            }
        },

        hideAreas: function () {
            this.map.removePolygonsByType(this.AREA)
        },

        fetchAreaGroup: function(id) {
            if (id) {
                this.loading = true
                this.restFetch(this.areaGroupUrl + '/id/' + id, this.handleAreaGroupResponse)
            }
        },
        handleAreaGroupResponse: function (response) {
            this.loading = false
            if (response) {
                this.visibleGroup = response.data
                this.showAreas()
            }
        },


    }
}
</script>
<style scoped>
    .speed-button {
        font-weight: 600;
        text-align: center;
        margin: .1em;
        height: 1.1em;
        cursor: pointer;
        padding: 0;
        font-size: 2em;
        color: #90b677;
    }

    .speed-button:hover {
        font-weight: 800;
        color: #00FF21;
    }

    .speed-button:focus, .speed-button::selection {
        background-color: transparent;
    }

    .trip-simulation-container {
        color: #FFFFFF;
        background-color: rgba(43, 43, 43, 0.8);
        border: 1px solid #404041;
        min-width: 30vw;
        z-index: 2;
        position: relative;
        width: fit-content;
        border-radius: .5em;
        margin: .5em;
    }

    .speed-container {
        margin-top: .6em;
        text-align: center;
        font-size: 2em;
        font-weight: bold;
        text-shadow: 3px 3px #000000;
        color: #FFFFFF;
        padding: .25em;
    }

    .speed-value-container {
        text-align: center;
        font-size: 3em;
        font-weight: bold;
        text-shadow: 3px 4px #000000;
        color: #FFFFFF;
        padding: .1em;
        padding-top: .2em;
    }

    .player-control-container {
        margin: auto;
        margin-top: .5em;
        color: #FFFFFF;
        font-size: 2em;
        height: 2em;
        width: 2em;
        text-align: center;
        border-radius: 1em;
        border: solid 2px #FFFFFF;
    }

    .player-contols {
        margin: .45em;
        cursor: pointer;
    }

    .player-subtitle {
        color: #FFFFFF;
        text-transform: uppercase;
        text-align: center;
        text-shadow: 2px 2px #000000;
        padding: 0;
        padding-left: .2em;
        padding-right: .2em;
    }

    .player-sub-value {
        color: #FFFFFF;
        font-size: 1.4em;
        text-shadow: 2px 2px #000000;
        padding: 0;
        padding-left: .2em;
        padding-right: .2em;
    }


</style>
